/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('@coreui/coreui');

/* Declare everything for Vue */
//Vue.config.performance = true
//Standard Page Elements
//import Vue from 'vue';
import VueRouter from 'vue-router';
import router from './router';
import store from './store';

import { VTooltip } from 'v-tooltip';
import VueMq from 'vue-mq';
import * as VueGoogleMaps from 'vue2-google-maps';

import datePicker from 'vue-bootstrap-datetimepicker';  
import vSelect from 'vue-select';
import { VueEditor } from 'vue2-editor';
import VueScrollTo from 'vue-scrollto';


import HighchartsVue from 'highcharts-vue';
import Highcharts from 'highcharts';
import mapInit from "highcharts/modules/map";
import markerClusters from "highcharts/modules/marker-clusters";


Vue.component('loader-layout', require('./layouts/LoaderLayout.vue').default);
Vue.component('app-layout', require('./layouts/AppLayout.vue').default);
Vue.component('header-layout', require('./layouts/HeaderLayout.vue').default);
Vue.component('footer-layout', require('./layouts/FooterLayout.vue').default);

/* Globally re-used components */
Vue.component('checkin-create-modal', require('./components/CheckinCreateModal.vue').default);
Vue.component('physician-create-modal', require('./components/PhysicianCreateModal.vue').default);
Vue.component('route-create-modal', require('./components/RouteCreateModal.vue').default);
Vue.component('physician-map-simple', require('./components/PhysicianMapSimple.vue').default);
Vue.component('physician-map-and-table', require('./components/PhysicianMapAndTable.vue').default);
Vue.component('page-loading', require('./components/PageLoading.vue').default);
Vue.component('file-field', require('./components/FileField.vue').default);
Vue.component('datePicker', datePicker);
Vue.component('v-select', vSelect);
Vue.component('VueEditor', VueEditor);

Vue.prototype.moment = moment;
Vue.prototype.numeral = numeral;

Vue.directive('tooltip', VTooltip);


Vue.use(VueRouter);
Vue.use(VueScrollTo, { offset:-60 });
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCvzVBgc98-1V-9etHvq-wM3iGV3yTpeKE',
    libraries: 'places,drawing',
  },
});

Vue.use(VueMq, {
  breakpoints: {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: Infinity
  }
});

mapInit(Highcharts);
markerClusters(Highcharts);
Vue.use(HighchartsVue);

const app = new Vue({
    el: '#app',
    //components: { App },
    router,
    store,

    created() {
        //TODO: is there a way to call these on-demand? CALL IF NOT ANON
        if (window.auth_user) {
          this.$store.commit('setUser', window.auth_user);
          this.$store.commit('setPerms', window.perms);

          this.$store.dispatch('fetchOptions');
          this.$store.dispatch('fetchGroups');
          this.$store.dispatch('fetchPhysicians');
          this.$store.dispatch('fetchCampaigns');
          this.$store.dispatch('fetchRoutes');
        }
    }
});


/* All the rest */
window.addEventListener('online', () => {
  document.getElementById("body").classList.remove("offline");
});

window.addEventListener('offline', () => {
  document.getElementById("body").classList.add("offline");
});



numeral.register('format', 'phone', {
  regexps: {
    format: /\+?N?[\.\ \-]?\(?NNN\)?[\.\ \-]?NNN[\.\ \-]?NNNN/
  },
  format : function (value, formatString) {
    function normalize(phoneNumber) {
      return phoneNumber.toString().replace(
        /^[\+\d{1,3}\-\s]*\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
        "$1$2$3"
      );
    }

  function format(phoneNumber, formatString) {
    phoneNumber = normalize(phoneNumber);
    for (var i = 0, l = phoneNumber.length; i < l; i++) {
      formatString = formatString.replace("N", phoneNumber[i]);
    }
    return formatString;
  }

  return format(value, formatString);
  }
});

//put some nice error handling in for all axios calls
axios.interceptors.response.use(
  function(response) { return response; }, 
  function(error) {
      if (error.response.status === 401) {
        location.replace('/login');
        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: true,
          icon: 'error',
          title: 'Authentication expired. Redirecting to the login page.',
        });
      }       
  
      else if (error.response.status === 422) {
        return Promise.reject(error);
      }

      else {
        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: true,
          icon: 'error',
          title: '<div><div class="mb-2">There was a problem with your request.<br>Check your input or try refreshing the page.</div><div class="text-base"><span class="text-gray-500">Error code:</span> <strong>422</strong><br><span class="text-gray-500">Error message:</span> <strong>The given data was invalid.</strong></div></div>',
        });           
      }

      return Promise.reject(error);
});